export default __webpack_public_path__ + "static/media/groupRank.3c05f665.svg";